import React, { FC } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { IExercise } from './exercise.interface';
import styles from './exercise.module.scss';

import { ActionMenu } from 'views/components/ActionMenu';
import { ExerciseCard } from 'views/components/ExerciseCard';

interface IExerciseProps {
  exerciseData: IExercise;
  handleMenuOpen: (exercise: IExercise) => void;
  handleEdit: () => void;
  handleRemove: () => void;
}

const Exercise: FC<IExerciseProps> = props => {
  const { exerciseData, handleMenuOpen, handleEdit, handleRemove } = props;
  const intl = useIntl();
  const optionsAriaLabel = intl.formatMessage({ id: 'exercise.btn.options' });

  return (
    <ExerciseCard
      exerciseData={exerciseData}
      actions={
        <div className={styles.exercise__button}>
          <ActionMenu
            triggerAriaLabel={optionsAriaLabel}
            onOpen={() => handleMenuOpen(exerciseData)}
            items={[
              {
                id: 'edit',
                label: <FormattedMessage id="action-menu.item.edit" />,
                onSelect: handleEdit,
              },
              {
                id: 'remove',
                label: <FormattedMessage id="action-menu.item.remove" />,
                onSelect: handleRemove,
                tone: 'danger',
              },
            ]}
            menuWidth="wide"
          />
        </div>
      }
    />
  );
};

export { Exercise };
